import jQuery from "jquery";
import 'jquery-ui/ui/core';
import 'jquery-ui/ui/widgets/accordion';
import 'jquery-ui/ui/widgets/accordion';
import 'select2';
import 'slick-slider';

window.$ = window.jQuery = jQuery;

import fastdom from 'fastdom';

const headerElement = window.document.getElementById('site-header');
const preheaderElement = window.document.getElementById('preheader-section');
const pageOverlayElement = window.document.querySelector('.page-overlay');
const navigationElement = window.document.getElementById('site-navigation');
const sidebarElement = window.document.getElementById('sidebar-navigation-drawer');
const openDrawer = window.document.getElementById('open-drawer');

let isOpen = !1;

window.addEventListener("scroll", checkTransparentHeader);
window.addEventListener("resize", checkHeaderHeight);

headerElement.addEventListener("mouseenter", focusNavigation);
headerElement.addEventListener("mouseleave", blurNavigation);
headerElement.addEventListener("focusin", focusNavigation);
headerElement.addEventListener("focusout", blurNavigation);

function checkHeaderHeight()
{
    fastdom.mutate(function () {
        document.documentElement.style.setProperty("--header-height", headerElement.offsetHeight + "px");
    })
}

function checkTransparentHeader()
{
    const offset = 10;

    fastdom.measure(function () {
        navigationElement.lastScrollPosition = window.pageYOffset
    });
    fastdom.mutate(function () {
        navigationElement.lastScrollPosition <= offset ? navigationElement.classList.add("transparent-header") : navigationElement.classList.remove("transparent-header")
    });

}

function focusNavigation(event)
{
    fastdom.mutate(function () {
        navigationElement.classList.remove("transparent-header");
    });
}

function blurNavigation()
{
    checkTransparentHeader();
}

if (openDrawer !== null) {
    openDrawer.addEventListener( "click", function ( e ) {
        if ( !isOpen ) {
            e && e.preventDefault(),
              sidebarElement.setAttribute( "aria-hidden", "false" ),
              calculateMaxHeight(),
              document.documentElement.classList.add( "overflow-hidden" ),
              document.querySelector( "#site-header" ).style.zIndex = "",
              pageOverlayElement.classList.add( "visible", "opacity-50" ),
              pageOverlayElement.classList.remove( "invisible", "opacity-0" ),
              isOpen = !0;
        }
    } );
}

window.document.getElementById("close-drawer").addEventListener("click", function (e) {
    isOpen && (e && e.preventDefault(),
      sidebarElement.setAttribute("aria-hidden", "true"),
      document.documentElement.classList.remove("overflow-hidden"),
      pageOverlayElement.classList.remove("visible","opacity-50"),
      pageOverlayElement.classList.add("invisible","opacity-0"),
      isOpen = !1);
});

function calculateMaxHeight()
{
    sidebarElement.style.maxHeight = window.innerHeight + "px"
}

document.addEventListener("DOMContentLoaded", function(){

    if (typeof(preheaderElement) != 'undefined' && preheaderElement != null) {
        document.documentElement.style.setProperty('--preheader-section-height', preheaderElement.offsetHeight + 'px');
    } else {
        document.documentElement.style.setProperty('--preheader-section-height', '0px');
    }
    document.documentElement.style.setProperty('--header-height', headerElement.offsetHeight + 'px');
    document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
});

function sidebarMenu( node ) {
    var selector = ( arguments.length > 0 && undefined !== arguments[0] ) ? jQuery( node ) : jQuery( '.sidebar-navigation-menu .sidebar-navigation' ),
      itemMenu = selector.find( '.menu-item-has-children > a' );
    itemMenu.each(
      function( i, ele ) {
          jQuery( ele ).on(
            'click',
            function( e ) {
                e.preventDefault();
                var t           = jQuery( this ),
                  nextSibling = t.siblings( 'ul' ),
                  allSubMenu  = t.parent().parent().find( 'li .sub-menu' ),
                  allItemMenu = t.parent().parent().find( '.menu-item-has-children > a' );
                if ( t.hasClass( 'active' ) ) {
                    t.removeClass( 'active' );
                } else {
                    allItemMenu.removeClass( 'active' );
                    t.addClass( 'active' );
                }
                if ( nextSibling.hasClass( 'show' ) ) {
                    nextSibling.slideUp(
                      200,
                      function() {
                          jQuery( this ).removeClass( 'show' );
                      }
                    );
                } else {
                    allSubMenu.slideUp(
                      200,
                      function() {
                          jQuery( this ).removeClass( 'show' );
                      }
                    );
                    nextSibling.slideToggle(
                      200,
                      function() {
                          jQuery( this ).toggleClass( 'show' );
                      }
                    );
                }
            }
          );
      }
    );
}

jQuery(document).ready(function ($)  {

    function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
        } else {
            var expires = "";
        }
        document.cookie = name + "=" + value + expires + "; path=/";
    }
    jQuery(function () {
        jQuery("a.cookie-click").click(function () {
            createCookie("acceptCookies", true, 300);
        });
    });

    sidebarMenu();

    jQuery(".blocks--accordion-items").accordion({
        header: ".accordion-item--title",
        icons: false,
        collapsible: true,
        active: false,
        heightStyle: "content",
    });

    $('.select-single').select2({
        minimumResultsForSearch: -1
    });

    const article_slider = $(".blocks--slider-wrapper:not(.slick-initialized)");

    article_slider.each(function() {
        $(this).slick({
            infinite: false,
            adaptiveHeight: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots:true,
            appendDots: '.blocks--slider-controls-dots',
            prevArrow: $(this).parent().find( ".blocks--slider-controls-prev" ),
            nextArrow:$(this).parent().find( ".blocks--slider-controls-next" ),
            responsive: [
                {
                    breakpoint: 1536,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1280,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });

    const reviews_slider = $(".blocks--reviews-slider-wrapper:not(.slick-initialized)");

    reviews_slider.each(function() {
        $(this).slick({
            infinite: true,
            adaptiveHeight: false,
            speed: 900,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots:true,
            arrows:false,
            autoplay:true,
            fade:true,
            appendDots: '.blocks--reviews-slider-controls-dots'
        });
    });

    if( $('#map').length ) {
        google.maps.event.addDomListener( window, 'load', initializeMap );
    }

});
